import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { mapMutations, mapGetters } from 'vuex';
export default {
  computed: _objectSpread({}, mapGetters(['$UnreadExportMessionNum'])),
  methods: _objectSpread(_objectSpread({}, mapMutations('d2admin/user', ['SET_unreadExportMessionNum'])), {}, {
    setUnreadExportMessionNum: function setUnreadExportMessionNum() {
      this.SET_unreadExportMessionNum(this.$UnreadExportMessionNum + 1);
    }
  })
};